import AppNavigationBar from '@rio-cloud/rio-uikit/AppNavigationBar';
import ExpanderList from '@rio-cloud/rio-uikit/ExpanderList';
import { useState } from 'react';
import { FormattedDate, FormattedMessage, useIntl } from 'react-intl';

import type { StopDetails } from '#domain/Stop.ts';
import { TimeDifference } from '#utils/timeDifference.tsx';

import { KeyValue } from '../../shared/KeyValue.tsx';
import { MaterialToExpanderListItem } from '../../shared/MaterialExpanderListItem.tsx';
import { TimeTooltip } from '../../shared/TimeTooltip.tsx';

type TourStopMaterialListProps = {
    onBack: () => void;
    stop?: StopDetails;
};

export const TourStopMaterialList = ({ onBack, stop }: TourStopMaterialListProps) => {
    const [selectedItemIndex, setSelectedItemIndex] = useState<number | undefined>(0);
    const intl = useIntl();

    const ExpanderListItems = !stop
        ? []
        : stop?.materials.map((material, index) =>
              MaterialToExpanderListItem(material, index, index === selectedItemIndex, setSelectedItemIndex)
          );

    return (
        <>
            <AppNavigationBar
                title={intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.tours.stop-details.loadingConfirmation',

                    defaultMessage: 'Load',
                })}
                onNavigateBack={onBack}
                className='border border-bottom-only'
            />
            {stop && (
                <div className='padding-15 bg-lightest'>
                    <div className='text-medium margin-bottom-5'>
                        {stop.location?.street} {stop.location?.city}
                    </div>
                    <KeyValue
                        keyData={intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.tours.stop-details.activity',

                            defaultMessage: 'Activity',
                        })}
                        valueData={
                            <FormattedMessage id={`intl-msg:ordercom-cloud-frontend.tours.stop.type.${stop.type}`} />
                        }
                    />
                    <KeyValue
                        keyData={intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.tours.stop-details.arrivalTime',

                            defaultMessage: 'Arrival time',
                        })}
                        valueData={
                            <TimeTooltip value={stop.startTarget}>
                                <div className='flex-1-1-0 text-medium'>
                                    <FormattedDate
                                        value={stop.startActual ?? stop.startTarget}
                                        timeStyle={'short'}
                                        dateStyle={'short'}
                                    />
                                    <TimeDifference actual={stop.startActual} expected={stop.startTarget} />
                                </div>
                            </TimeTooltip>
                        }
                    />
                    <KeyValue
                        keyData={intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.tours.stop-details.departureTime',

                            defaultMessage: 'Departure time',
                        })}
                        valueData={
                            <TimeTooltip value={stop.endTarget}>
                                <div className='flex-1-1-0 text-medium'>
                                    <FormattedDate
                                        value={stop.endActual ?? stop.endTarget}
                                        timeStyle={'short'}
                                        dateStyle={'short'}
                                    />
                                    <TimeDifference actual={stop.endActual} expected={stop.endTarget} />
                                </div>
                            </TimeTooltip>
                        }
                    />
                </div>
            )}
            <ExpanderList
                items={ExpanderListItems}
                className='border border-left-none border-right-none rounded-none'
            />
        </>
    );
};
